// extracted by mini-css-extract-plugin
export default {"print_container":"PrintPage_print_container__Rsfuz"};